import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ERModal from "../../components/ERModal";
import WorkflowForm from "../../components/WorkflowForm";
import {
    createLeaveDay,
    deleteAailableTime,
    deleteErrorCodeLeaveDay,
    getAvailableTime,
    getEmployeeAndManagerLeader,
    getLeaveTypes,
} from "../../core/actions/newLeaveRequestAction";
import functionCommon from "../../core/common/function";
import { commonConstants } from "../../core/constant/common.constants";
import CONSTANT from "../../core/constant/constant";

const initData = {
    dataLeaveRequest: {
        requestedForId: "",
        managerLeaderId: "",
        projectManagerId: [],
        leaveTypeId: "",
        dayFrom: "",
        dayTo: "",
        requestTimeOff: "",
        leaveReason: "",
        comment: "",
    },
    isError: {
        formError: {},
    },
    dataWorkLog: {
        workLog: [],
    },
};

const listParam = {
    paramLeaveTypes: {
        sortBy: "id-ASC",
    },
    paramEmployeeAndManagerLeader: {
        employeeBy: "firstName-ASC",
        managerLeaderBy: "firstName-ASC",
    },
    paramAvailableTime: {
        employeeId: 0,
        leaveTypeId: 0,
    },
    paramCreateLeaveDay: {
        requestedForId: 0,
        managerLeaderId: 0,
        projectManagerId: 0,
        leaveTypeId: 0,
        dayFrom: "",
        dayTo: "",
        requestTimeOff: 0,
        leaveReason: "",
        comment: "",
        radio: "",
        workLog: "",
    },
};

const ManagementPage = () => {
    const { t } = useTranslation();
    const [dataCreateLeaveRequest, setDataCreateLeaveRequest] = useState(initData.dataLeaveRequest);
    const [dataWorkLog, setDataWorkLog] = useState(initData.dataWorkLog);
    const leaveType = useSelector((state) => state.newLeaveRequestReducer.listLeaveType);
    const availableTime = useSelector((state) => state.newLeaveRequestReducer.listAvailableTime);
    const listEmployee = useSelector((state) => state.newLeaveRequestReducer.listEmployee);
    const listManagerLeader = useSelector((state) => state.newLeaveRequestReducer.listManagerLeader);
    const { submitting } = useSelector((state) => state.newLeaveRequestReducer);
    const errorSubmit = useSelector((state) => state.newLeaveRequestReducer.errorCode);
    const [error, setError] = useState(initData.isError);
    const employeeIdLogin = functionCommon.getInfoUser("employeeId");
    const [open, setOpen] = useState(false);
    const [modalStyle, setModalStyle] = useState("");
    const [textContent, setTextContent] = useState("");
    const [message, setMessage] = useState(null);
    const [listDay, setListDay] = useState([
        {
            day: "",
            value: { day: "", hours: "" },
            isError: "",
        },
    ]);

    const history = useHistory();
    const dispatch = useDispatch();
    const isNotValidate = (_formError) => {
        setError(_formError);
    };

    // Check validate form
    const checkValidate = () => {
        let validate = false;
        let _formError = {};
        const requestedTimeOff = dataCreateLeaveRequest.requestTimeOff;
        const leaveTypeId = dataCreateLeaveRequest.leaveTypeId;
        const managerLeaderId = dataCreateLeaveRequest.managerLeaderId;
        const formatDayFrom = dataCreateLeaveRequest.dayFrom;
        const formatDayTo = dataCreateLeaveRequest.dayTo;
        const dayFrom = new Date(moment(formatDayFrom, "DDMMYYYY ").local());
        const dayTo = new Date(moment(formatDayTo, "DDMMYYYY ").local());
        if (!managerLeaderId) {
            _formError["managerLeaderId"] = "message.605";
        } else {
            _formError["managerLeaderId"] = "";
        }

        if (requestedTimeOff === "") {
            _formError["requestTimeOff"] = "message.604";
        } else if (Number(requestedTimeOff) === 0) {
            _formError["requestTimeOff"] = "message.606";
        } else {
            _formError["requestTimeOff"] = "";
        }

        if (!leaveTypeId) {
            _formError["leaveTypeId"] = "message.603";
        } else {
            _formError["leaveTypeId"] = "";
        }

        if (dayTo < dayFrom) {
            _formError["dateError"] = "message.040";
        } else {
            _formError["dateError"] = "";
        }

        if (!managerLeaderId) {
            validate = false;
            isNotValidate(_formError);
        } else if (requestedTimeOff === "") {
            validate = false;
            isNotValidate(_formError);
        } else if (Number(requestedTimeOff) === 0) {
            validate = false;
            isNotValidate(_formError);
        } else if (!leaveTypeId) {
            validate = false;
            isNotValidate(_formError);
        } else if (dayTo < dayFrom) {
            validate = false;
            isNotValidate(_formError);
        } else {
            validate = true;
            setError({});
        }
        return validate;
    };

    const checkValidateInputHours = () => {
        let validate = true;
        const workLog = listDay;
        if (workLog.length > commonConstants.NUMBER_DAY_IN_MONTH) {
            return validate;
        }
        workLog.forEach((item) => {
            if (item.value.hours === "") {
                validate = false;
                item.isError = true;
            } else {
                item.isError = false;
            }
        });
        return validate;
    };


    const sendDataRequestLeave = (chilDataLeaveRequest) => {
        setDataCreateLeaveRequest(chilDataLeaveRequest);
    };

    const sendDataWorkLog = (chilDataWorkLog) => {
        setDataWorkLog(chilDataWorkLog);
    };

    const handelBack = () => {
        history.push("/my-leave-request");
    };

    // Change manager leader
    const changeManagetLeader = () => {
        setError({ ...error, managerLeaderId: "" });
    };

    // Change datepicker
    const changeDatePicker = () => {
        setError({ ...error, dateError: "" });
    };

    // Call api on change Leave Type
    const changeLeaveType = (value) => {
        let requestedForId;
        if (dataCreateLeaveRequest.requestedForId === "") {
            requestedForId = employeeIdLogin;
        } else {
            requestedForId = dataCreateLeaveRequest.requestedForId;
        }
        const leaveTypeId = value;
        listParam.paramAvailableTime = {
            employeeId: requestedForId,
            leaveTypeId: leaveTypeId,
        };
        setError({ ...error, leaveTypeId: "", requestTimeOff: "" });
        dispatch(getAvailableTime(listParam.paramAvailableTime));
    };

    // Change request time off
    const changeRequestTime = () => {
        setError({ ...error, requestTimeOff: "" });
    };

    // Roundoff number to nearest 0.5
    const roundHalf = (num) => {
        return Math.ceil(num * 2) / 2;
    };

    // Round to at most 2 decimal
    const roundTowDecimal = (num) => {
        return Number(num).toFixed(2);
    };

    // Event when click btn create
    const handleSubmit = () => {
        if (!checkValidate() || !checkValidateInputHours()) return;
        let requestedForId;
        let requestTimeOff = Number(dataCreateLeaveRequest.requestTimeOff);
        if (dataCreateLeaveRequest.requestedForId === "") {
            requestedForId = employeeIdLogin;
        } else {
            requestedForId = dataCreateLeaveRequest.requestedForId;
        }
        if (dataCreateLeaveRequest.radio === commonConstants.VALUE_RADIO_HOUR) {
            if (dataCreateLeaveRequest.leaveTypeId === commonConstants.SPECIAL_LEAVE_TYPE) {
                const _requestTime = roundTowDecimal(requestTimeOff / commonConstants.WORK_TIME);
                requestTimeOff = Number(_requestTime);
            } else {
                const _requestTime = roundHalf(requestTimeOff / commonConstants.WORK_TIME);
                requestTimeOff = Number(_requestTime);
            }
        }
        const formatDayFrom = dataCreateLeaveRequest.dayFrom;
        const formatDayTo = dataCreateLeaveRequest.dayTo;
        const dayFrom = moment(formatDayFrom, "DDMMYYYY").format("YYYY-MM-DD") + " " + dataCreateLeaveRequest.timeFrom;
        const dayTo = moment(formatDayTo, "DDMMYYYY").format("YYYY-MM-DD") + " " + dataCreateLeaveRequest.timeTo;
        const projectManagerId = dataCreateLeaveRequest.projectManagerId.toString();
        const _dataWorkLog = listDay;
        const lengthDataWorkLog = _dataWorkLog.length;
        const _dataLogWork = [];
        let dataLogWork = "";
        if (lengthDataWorkLog !== 0 && lengthDataWorkLog < 30) {
            for (let i = 0; i < lengthDataWorkLog; i++) {
                if (_dataWorkLog[i].value.hours !== "" && _dataWorkLog[i].value.hours != 0) {
                    _dataLogWork.push(_dataWorkLog[i].value);
                    const data = JSON.stringify(
                        _dataLogWork.reduce((obj, item) => Object.assign(obj, { [item.day]: item.hours }), {})
                    );
                    dataLogWork = data;
                }
            }
        } else {
            dataLogWork = "";
        }
        listParam.paramCreateLeaveDay = {
            requestedForId: requestedForId,
            managerLeaderId: dataCreateLeaveRequest.managerLeaderId,
            "projectManagerId[]": projectManagerId,
            leaveTypeId: dataCreateLeaveRequest.leaveTypeId,
            dayFrom: dayFrom,
            dayTo: dayTo,
            requestTimeOff: Number(requestTimeOff),
            leaveReason: dataCreateLeaveRequest.leaveReason,
            comment: dataCreateLeaveRequest.comment,
            workLog: dataLogWork,
        };
        dispatch(createLeaveDay(listParam.paramCreateLeaveDay));
    };

    const handelClose = () => {
        setOpen(false);
        dispatch(deleteErrorCodeLeaveDay());
    };

    const triggerMessage = () => {
        setTimeout(() => {
            setMessage(null);
            dispatch(deleteErrorCodeLeaveDay());
        }, 2000);
    };

    const changeRequestFor = (value) => {
        if (value && dataCreateLeaveRequest.leaveTypeId !== "") {
            listParam.paramAvailableTime = {
                employeeId: value,
                leaveTypeId: dataCreateLeaveRequest.leaveTypeId,
            };
            dispatch(getAvailableTime(listParam.paramAvailableTime));
        } else if (!value && dataCreateLeaveRequest.leaveTypeId !== "") {
            listParam.paramAvailableTime = {
                employeeId: employeeIdLogin,
                leaveTypeId: dataCreateLeaveRequest.leaveTypeId,
            };
            dispatch(getAvailableTime(listParam.paramAvailableTime));
        }
    };

    const employeeProcess = (rawData) => {
        if (rawData && rawData.length > 0) {
            const employee = rawData.map((ele) => {
                return {
                    value: ele.employeeId,
                    name: ele.employeeCode + " - " + ele.employeeName,
                }
            });
            return employee;
        } else return [];
    };

    // Call api EmployeeAndManagerLeader & LeaveType
    useEffect(() => {
        dispatch(getEmployeeAndManagerLeader(listParam.paramEmployeeAndManagerLeader));
        dispatch(getLeaveTypes(listParam.paramLeaveTypes));
        dispatch(deleteAailableTime());
    }, []);

    useEffect(() => {
        const checkError = () => {
            if (errorSubmit === commonConstants.ERROR_CODE) {
                setOpen(true);
                setModalStyle("errorModal");
                setTextContent(t("labels.leaveYearError"));
            } else if (errorSubmit === commonConstants.ERROR_CODE_FOR_YEAR) {
                setOpen(true);
                setModalStyle("errorModal");
                setTextContent(t("labels.oldYearError"));
            } else if (errorSubmit === CONSTANT.messageCode.requestFail) {
                setMessage(t(`message.${errorSubmit}`));
                triggerMessage();
            }
        };
        checkError();
    }, [errorSubmit]);

    return (
        <div className="new-leave-request">
            <h2 className="page-heading">
                <span onClick={handelBack}>{t("labels.leaveManagemnet")}/ </span>
                <span onClick={handelBack}>{t("labels.myLeaveRequest")}/ </span>
                <span onClick={functionCommon.goToPage("new-leave-request")}>{t("button.newLeaveRequest")}</span>
            </h2>
            <WorkflowForm
                changeLeaveType={changeLeaveType}
                changeRequestTime={changeRequestTime}
                changeManagetLeader={changeManagetLeader}
                changeRequestFor={changeRequestFor}
                sendData={sendDataRequestLeave}
                sendDataWorkLog={sendDataWorkLog}
                isError={error}
                handleSubmit={handleSubmit}
                leaveType={leaveType}
                availableTime={availableTime}
                listManagerLeader={employeeProcess(listManagerLeader)}
                listEmployee={employeeProcess(listEmployee)}
                isSubmitting={submitting}
                roundHalf={roundHalf}
                roundTowDecimal={roundTowDecimal}
                changeDatePicker={changeDatePicker}
                message={message}
                setListDay={setListDay}
                listDay={listDay}
            />
            <ERModal
                size={"mini"}
                open={open}
                title={t("labels.validatError")}
                handleClose={handelClose}
                modalStyle={modalStyle}
                textContent={textContent}
            />
        </div>
    );
};

export default ManagementPage;
